<template>
    <div class="solution-chemical-industry-page">
        <div class="page-content">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="solution-children-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <solution-info-block :data-val="dataInfo"></solution-info-block>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
    </div>
</template>

<script>
    import SolutionInfoBlock from '../../../../../components/solution-info-block/solution-info-block'
    import ChemicalIndustryShow from '../../../../image/common/chemical_industry_show.png'
    export default {
        name: "solution-chemical-industry-page",
        components:{
            SolutionInfoBlock
        },
        data(){
            return{
                dataInfo:{
                    business:[
                        {title:null,info:['通过传统手段对化工园区进行监测管理，如LDAR人工检测、标准站大气检测、水质监测等等，虽然精度高，但缺点明显:','1. 成本高昂,需专人巡守','2. 数量少,覆盖密度低 ','3. 缺乏污染源准确定位能力','4. 追踪预警能力薄弱',' 5. LDAR依赖人工巡检，缺乏低成本实时在线监测能力','...... ','而物联网监测能有效弥补其中不足。']},
                    ],
                    programme:[{
                        image:ChemicalIndustryShow,info:'劲步的智慧化工园区解决方案'
                    }],
                    customerTitle:'方案优势',
                    customer:[
                        {title:null,info:['“感知硬件+平台软件”同步作用 ','“自主可控+轻量级低成本”物联专网同步建成，具体在通讯费用、信号覆盖、数据安全、传输功耗、终端提供、业务扩展等方面优势明显','“重点问题+全面整治”同步结合，全面建立环保指标监测体系 ','“园区监管+服务企业”同步形成，即通过建立一张物联专网，不仅为开发区管委会的安全生产和环境保护提供了技术监管手段，也可同步复用，为开发区上百家企业的智慧化生产运营提供了网络接入']}
                    ],
                }
            }
        }
    }
</script>

<style lang="scss" src="../../solution-page.scss" scoped>

</style>
